import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICreateRequest, IOrganization, IProfile, IResponse, IRole } from '@interfaces/index';
import { ICreate } from 'projects/ui-components/src/interfaces/ICohort';
import { switchMap } from 'rxjs';
import { AppService } from '@ui-components/services';
import { OrganizationService } from '../../services/organization.service';

@Component({
  selector: 'app-organization-modal',
  templateUrl: './organization-modal.component.html',
  styleUrls: ['./organization-modal.component.scss']
})
export class OrganizationModalComponent implements OnInit {
  form: FormGroup;
  loading = false;
  organizations: IOrganization[] = [];
  profile: IProfile | null = null;
  require_approval: boolean = false;
  roles: IRole[] = [];
  isEdit: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IOrganization | null,
    protected _app_service: AppService,
    protected _organization_service: OrganizationService,
    protected _fb: FormBuilder,
    protected _dialog_ref: MatDialogRef<OrganizationModalComponent>
  ) {
    this.form = this._fb.group({
      name: [null, Validators.required],
      require_approval: [false]
    });

    this.isEdit = !!this.data;
  }

  ngOnInit(): void {
    if (this.isEdit && this.data) {
      this.form.patchValue({
        name: this.data.name,
        require_approval: this.data.require_approval
      });
    }

    this._app_service.getProfile().pipe(
      switchMap((response: IResponse<IProfile>) => {
        this.profile = response.data;
        return this._organization_service.getOrgsById(this.profile.org_id);
      })
    ).subscribe((response: IResponse<IOrganization[]>) => {
      this.organizations = response.data;
    });
  }

  saveOrganization(): void {
    if (this.form.invalid || this.loading) {
      return;
    }

    const organizationData: ICreateRequest = {
      name: this.form.get('name')?.value,
      require_approval: this.form.get('require_approval')?.value,
    };

    this.loading = true;

    const save = this.isEdit && this.data?.id
      ? this._organization_service.updateOrganization(organizationData.name, this.data.id, organizationData.require_approval)
      : this._organization_service.createOrganization(organizationData.name, organizationData.require_approval);

    save.subscribe(
      (response: IResponse<ICreate>) => {
        this._dialog_ref.close(response.data);
        this.loading = false;
      },
      (error) => {
        console.error('API error:', error);
        this.loading = false;
      }
    );
  }

  onCancel(): void {
    this._dialog_ref.close(null);
  }
}
